import ChatWidget from './ChatWidget';

export { default as ChatPanel } from './ChatPanel';
export { default as ChatComposer } from './ChatComposer';
export { default as ChatThread } from './ChatThread';

export default ChatWidget;
